// extracted by mini-css-extract-plugin
export var badgeTextContainer = "_3s-2";
export var blackBorderOnHover = "_3s-7";
export var cell = "_3s-6";
export var cellContainer = "_3s-3";
export var checked = "_3s-8";
export var disabled = "_3s-5";
export var featuredIconCellContainer = "_3s-9";
export var featuredIconTextContainer = "_3s-b";
export var featuredIconWrapper = "_3s-a";
export var noBorder = "_3s-c";
export var orangeSelectedRow = "_ce-3";
export var overflowableText = "_3s-0";
export var overflowableTextContainer = "_3s-1";
export var row = "_3t-0";
export var rowCheckboxCell = "_3s-4";
export var selectableTable = "_ce-2";